import classNames from 'classnames';

import Typography, { TypographyProps } from './Typography';

import styles from '../../styles/typography/summary-title.module.css';

function SummaryTitle({ tag = 'h4', className = null, ...props }: TypographyProps) {
    return (
        <Typography tag={tag} className={classNames([styles.container, className])} {...props} />
    );
}

export default SummaryTitle;
